import CityPageTemplate from "../city-template/CityPageTemplate";
import { portsmouthConfig } from "./data";

export default function PortsmouthPage() {
  return <CityPageTemplate config={portsmouthConfig} />;
}